import "./landing-page-style.css";
import PageSeo from "../../custom/page-seo/page-seo";

//aAibo App 介紹頁（獨立 landing）
//  不掛在 MainLayout 底下，因此自帶 header / footer，深色主題與站台前台分開。
//  版面全部走純 CSS fluid（clamp + auto-fit grid），沒有 useIsMobile 雙 JSX。

//App 上架開關：正式上架後改 true，並把下面兩條商店連結換掉即可
const LAUNCHED = false;
const IOS_URL = "#download";
const ANDROID_URL = "#download";

//素材根目錄（client/public/images/aaibo）
const IMG = "/images/aaibo";

//法遵文件（目前掛在 HackMD，之後搬站只改這兩行）
const TERMS_URL = "https://hackmd.io/@6haHDxSMQPeSHmmc7TDlUA/BkGWpfewfx";
const PRIVACY_URL = "https://hackmd.io/@6haHDxSMQPeSHmmc7TDlUA/SJf8izgDzl";

//上架前 / 上架後兩套文案
const STATUS_BADGE = LAUNCHED
  ? "iOS ／ Android 現已上架"
  : "火熱推出 · 搶先下載";
const CTA_SUB = LAUNCHED
  ? "iOS 與 Android 雙平台皆已上架，下載後綁定元辰雲閣帳號即可同步命盤。"
  : "將命理帶入生活，每天都是專屬於你的一天！";

//跑馬燈詞條（渲染時會複製成兩份無縫接軌）
const MARQUEE_WORDS = [
  "八字",
  "紫微斗數",
  "奇門遁甲",
  "流日流月",
  "農民曆宜忌",
  "數字易經",
  "合盤解析",
  "真人命理師",
];

//01 陪伴：三張艾波卡片
const COMPANION_CARDS = [
  {
    key: "warn",
    icon: `${IMG}/aibo-warn.png`,
    alt: "提醒",
    title: "特殊日子，牠先開口",
    desc: "車關日、桃花日、得財日...等等，當天一打開，艾波就把該注意的事貼在你眼前。",
    tags: ["桃花日", "得財日", "車關日"],
  },
  {
    key: "cookie",
    icon: `${IMG}/aibo-cookie.png`,
    alt: "餵餅乾",
    title: "摸摸頭、餵餅乾",
    desc: "「艾波的小窩」是牠的專屬空間。每天摸一次、餵一塊餅乾，親密度慢慢養起來。",
    intimacy: 68,
  },
  {
    key: "mood",
    icon: `${IMG}/aibo-fu.png`,
    alt: "好運",
    title: "情緒隨你的運勢走",
    desc: "財運亮燈時牠笑得誇張，該收斂的日子牠也會皺眉——一眼就懂今天的氣場。",
    moods: [
      `${IMG}/aibo-happy.png`,
      `${IMG}/aibo-scale.png`,
      `${IMG}/aibo-sleep.png`,
    ],
  },
];

//02 四大功能：對應 App 四個 TAB
const FEATURES = [
  {
    no: "01",
    tab: "TAB 1 ／ 流日月曆",
    title: "今天的運勢，一眼看完",
    desc: "農民曆宜忌、干支流日、財運事業愛情三項指標，加上 AI 依你的命盤生成的每日建議。",
    points: [
      "財運／事業／愛情 % 指標，點開看細節",
      "農民曆宜忌與今日干支、節氣一次呈現",
      "AI 每日建議：具體到「今天適合談什麼」",
      "流月解析：整月走向與該月十神主題",
    ],
    shotA: `${IMG}/shots/tab1-calendar.jpg`,
    shotB: `${IMG}/shots/tab1-fortune.jpg`,
  },
  {
    no: "02",
    tab: "TAB 2 ／ 命理服務",
    title: "想問人的時候，有真的老師",
    desc: "從一對一提問到完整報告，元辰雲閣的命理師團隊在 App 裡就找得到。",
    points: [
      "問問老師：真人命理師一對一，回覆進個人頁",
      "各類報告：流年之書、十年大運、愛情合盤、親子合盤",
      "奇門遁甲擇時擇日：選事件 → 選盤別 → 找最佳時辰",
      "命理師專屬擇日：結婚、開業、入宅由老師親選",
    ],
    shotA: `${IMG}/shots/tab2-services.jpg`,
    shotB: `${IMG}/shots/tab2-teacher.jpg`,
  },
  {
    no: "03",
    tab: "TAB 3 ／ 雲閣藏書",
    title: "看得懂命理，才用得上命理",
    desc: "命理知識文章庫，分一般文章與工具書兩類。可搜尋、可收藏，慢慢累積自己的底子。",
    points: [
      "八字／紫微／奇門／數字易經分類瀏覽",
      "工具書入門到進階，速查表隨時翻",
      "收藏與愛心，建立自己的書單",
      "全文搜尋，想到什麼就查什麼",
    ],
    shotA: `${IMG}/shots/tab3-library.jpg`,
    shotB: `${IMG}/shots/tab3-search.jpg`,
  },
  {
    no: "04",
    tab: "TAB 4 ／ 我的",
    title: "你的命盤，完整收在一頁",
    desc: "八字與紫微命盤、十年大運、流年推演，並整理成七大方向的解讀。",
    points: [
      "八字命盤 ＋ 紫微命盤雙系統對照",
      "十年大運與流年走勢時間軸",
      "個性／事業／財運／感情／健康／家庭／人際 七大方向",
      "我的書房、點數與訂閱、好友命盤都在這裡",
    ],
    shotA: `${IMG}/shots/tab4-profile.jpg`,
    shotB: `${IMG}/shots/plate.jpg`,
  },
];

//好友系統補充條
const FRIEND_TAGS = ["加入好友命盤", "愛情合盤", "友情合盤", "標籤搜尋"];

//03 各類報告
const REPORTS = [
  {
    key: "flow-year",
    title: "流年之書",
    mascot: `${IMG}/aibo-fu.png`,
    desc: "一整年的運勢流月詳解。從今年的主軸講起，再拆到每個月該推進什麼、該避開什麼。",
    points: [
      "年度主題與十神走向總論",
      "十二個流月逐月解析與提醒",
      "財運／事業／感情三線的高低點時機",
      "全年關鍵日期整理，可對照流日月曆",
    ],
    meta: "約 30+ 頁 · 永久保存",
    badge: "最熱門",
  },
  {
    key: "love-match",
    title: "愛情合盤",
    mascot: `${IMG}/aibo-happy.png`,
    desc: "兩個人的命盤疊在一起看。相處的節奏、容易踩到的點、以及怎麼把差異變成互補。",
    points: [
      "雙方個性與情感需求對照",
      "契合度分析：溝通、金錢、生活步調",
      "容易產生摩擦的位置與化解方式",
      "關係的階段走勢與適合推進的時機",
    ],
    meta: "需雙方出生資料",
    badge: "情侶／夫妻",
  },
  {
    key: "family-match",
    title: "親子合盤",
    mascot: `${IMG}/aibo-pat.png`,
    desc: "孩子的天生特質，以及你和他的相處方式。用命盤理解，而不是用脾氣硬碰。",
    points: [
      "孩子的天賦傾向與學習方式",
      "父母與孩子的性格互動模式",
      "教養上該鼓勵與該放手的地方",
      "各成長階段的重點提醒",
    ],
    meta: "需親子雙方資料",
    badge: "家長推薦",
  },
];

//購買流程四步
const PURCHASE_STEPS = [
  "在命理服務專區挑選報告，價格與內容一次看清。",
  "填寫出生資料（合盤則填兩人），支援命盤直接帶入。",
  "系統生成期間可以離開，完成後推播通知你。",
  "報告收進「我的書房」，可重複閱讀、也能追加專業諮詢。",
];

const LandingPageComponent = () => {
  //錨點平滑捲動：不用全域 html{scroll-behavior}，避免影響站台其他頁
  const scrollToSection = (event, id) => {
    event.preventDefault();
    const target = document.getElementById(id);
    if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  //兩顆商店按鈕在 hero / CTA 都會用到，抽出來共用
  //  官方 badge 原生比例差 23.6%（Apple 2.72:1、Google 3.36:1）且規範禁止改變比例，
  //  兩顆不可能等寬等高，所以改成自製統一按鈕：外框尺寸完全一致，
  //  logo 仍取自官方原檔（Apple 從 badge SVG 抽出向量、Google 從 badge PNG 裁出三角形）
  const storeButtons = (
    <div className="lp-store-group">
      <a
        className="lp-store-btn"
        href={IOS_URL}
        aria-label="從 App Store 下載 aAibo"
      >
        <img className="lp-store-logo" src={`${IMG}/ic-apple.svg`} alt="" />
        <span className="lp-store-text">
          <span className="lp-store-name">App Store</span>
          <span className="lp-store-sub">立即下載</span>
        </span>
      </a>
      <a
        className="lp-store-btn"
        href={ANDROID_URL}
        aria-label="從 Google Play 下載 aAibo"
      >
        <img
          className="lp-store-logo lp-store-logo--play"
          src={`${IMG}/ic-google-play.png`}
          alt=""
        />
        <span className="lp-store-text">
          <span className="lp-store-name">Google Play</span>
          <span className="lp-store-sub">立即下載</span>
        </span>
      </a>
    </div>
  );

  return (
    <div className="landing-page">
      <PageSeo
        title="aAibo App"
        description="元辰雲閣把八字、紫微斗數與奇門遁甲，收進一隻會提醒你、也會撒嬌的小夥伴裡。每日運勢、農民曆宜忌、真人命理師諮詢，全在 aAibo。"
        path="/aaibo"
        ogImage="https://yuanchen.leinotek.com/images/aaibo/aibo-hero.png"
      />

      {/* 頁首導覽（sticky） */}
      <header className="lp-header">
        <div className="lp-brand">
          <img
            className="lp-brand-icon"
            src={`${IMG}/logo-icon.png`}
            alt="aAibo App 圖示"
          />
          <div className="lp-brand-text">
            <img
              className="lp-brand-wordmark"
              src={`${IMG}/logo-wordmark-white.png`}
              alt="aAibo"
            />
            <span className="lp-brand-sub">YUANCHEN 元辰雲閣</span>
          </div>
        </div>

        <nav className="lp-nav">
          <a href="#companion" onClick={(e) => scrollToSection(e, "companion")}>
            艾波陪伴
          </a>
          <a href="#features" onClick={(e) => scrollToSection(e, "features")}>
            四大功能
          </a>
          <a href="#reports" onClick={(e) => scrollToSection(e, "reports")}>
            各類報告
          </a>
          <a
            className="lp-nav-cta"
            href="#download"
            onClick={(e) => scrollToSection(e, "download")}
          >
            下載 App
          </a>
        </nav>
      </header>

      {/* Hero */}
      <section className="lp-hero">
        <div className="lp-hero-glow"></div>

        <div className="lp-hero-inner">
          <div className="lp-hero-copy">
            <div className="lp-badge">{STATUS_BADGE}</div>

            <h1 className="lp-hero-logo">
              <img src={`${IMG}/logo-wordmark-pink.png`} alt="aAibo" />
            </h1>

            <p className="lp-hero-slogan">
              命理不必冷冰冰。
              <br />
              讓艾波陪你，過好每一天。
            </p>

            <p className="lp-hero-desc">
              元辰雲閣把八字、紫微斗數與奇門遁甲，收進一隻會提醒你、也會撒嬌的小夥伴裡。每日運勢、農民曆宜忌、真人命理師諮詢，全在
              aAibo。
            </p>

            {storeButtons}
          </div>

          <div className="lp-hero-visual">
            <div className="lp-hero-halo"></div>
            <div className="lp-hero-ring"></div>
            <img
              className="lp-hero-mascot"
              src={`${IMG}/aibo-hero.png`}
              alt="aAibo 吉祥物 艾波"
            />
          </div>
        </div>
      </section>

      {/* 關鍵字跑馬燈：兩份相同內容無縫循環 */}
      <div className="lp-marquee">
        <div className="lp-marquee-track">
          {[0, 1].map((groupIndex) => (
            <span
              className="lp-marquee-group"
              key={groupIndex}
              aria-hidden={groupIndex === 1}
            >
              {MARQUEE_WORDS.map((word) => (
                <span key={word}>{word}</span>
              ))}
            </span>
          ))}
        </div>
      </div>

      {/* 01 陪伴 */}
      <section className="lp-companion" id="companion">
        <div className="lp-inner">
          <div className="lp-section-head">
            <span className="lp-eyebrow">01 ／ 陪伴</span>
            <h2 className="lp-section-title">牠不是功能，是每天在的那一個</h2>
            <p className="lp-section-desc">
              艾波住在 aAibo
              裡。該小心的日子牠會先提醒你，心情好的時候陪你討一塊餅乾——命理的距離，從此變得很近。
            </p>
          </div>

          <div className="lp-companion-grid">
            {COMPANION_CARDS.map((card) => (
              <div
                className={`lp-companion-card lp-companion-card--${card.key}`}
                key={card.key}
              >
                <img
                  className="lp-companion-icon"
                  src={card.icon}
                  alt={card.alt}
                />
                <div className="lp-companion-title">{card.title}</div>
                <p className="lp-companion-desc">{card.desc}</p>

                {/* 卡片底部依類型換成標籤 / 親密度條 / 表情列 */}
                {card.tags && (
                  <div className="lp-companion-tags">
                    {card.tags.map((tag) => (
                      <span key={tag}>{tag}</span>
                    ))}
                  </div>
                )}

                {card.intimacy !== undefined && (
                  <div className="lp-intimacy">
                    <div className="lp-intimacy-label">
                      <span>親密度</span>
                      <span className="lp-intimacy-value">
                        {card.intimacy}%
                      </span>
                    </div>
                    <div className="lp-intimacy-bar">
                      <div
                        className="lp-intimacy-fill"
                        style={{ width: `${card.intimacy}%` }}
                      ></div>
                    </div>
                  </div>
                )}

                {card.moods && (
                  <div className="lp-companion-moods">
                    {card.moods.map((mood) => (
                      <img src={mood} alt="" key={mood} />
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* 艾波的小窩 */}
          <div className="lp-nest">
            <div className="lp-nest-copy">
              <div className="lp-eyebrow">艾波的小窩</div>
              <h3 className="lp-nest-title">一個只屬於你們兩個的空間</h3>
              <p className="lp-nest-desc">
                親密度到 100% 有驚喜。養一隻會回應你的命理夥伴，是 aAibo
                最不像工具的地方。
              </p>
              <a
                className="lp-pill-btn"
                href="#download"
                onClick={(e) => scrollToSection(e, "download")}
              >
                養一隻艾波吧 →
              </a>
            </div>

            <div className="lp-nest-visual">
              <div className="lp-phone lp-phone--lg">
                <img
                  src={`${IMG}/shots/aibo-home.jpg`}
                  loading="lazy"
                  alt="艾波的小窩畫面"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 02 四大功能 */}
      <section className="lp-features" id="features">
        <div className="lp-inner">
          <div className="lp-section-head">
            <span className="lp-eyebrow">02 ／ 四大功能</span>
            <h2 className="lp-section-title">一天的運勢，一生的命盤</h2>
            <p className="lp-section-desc">
              四個分頁，覆蓋從「今天該不該出門」到「這十年往哪走」。
            </p>
          </div>

          <div className="lp-feature-list">
            {FEATURES.map((feature) => (
              <article className="lp-feature" key={feature.no}>
                <div className="lp-feature-copy">
                  <div className="lp-feature-label">
                    <span className="lp-feature-no">{feature.no}</span>
                    <span className="lp-feature-tab">{feature.tab}</span>
                  </div>

                  <h3 className="lp-feature-title">{feature.title}</h3>
                  <p className="lp-feature-desc">{feature.desc}</p>

                  <ul className="lp-point-list">
                    {feature.points.map((point) => (
                      <li key={point}>
                        <span className="lp-dot"></span>
                        <span>{point}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="lp-feature-shots">
                  <div className="lp-phone">
                    <img
                      src={feature.shotA}
                      loading="lazy"
                      alt={feature.title}
                    />
                  </div>
                  <div className="lp-phone lp-phone--offset">
                    <img
                      src={feature.shotB}
                      loading="lazy"
                      alt={feature.title}
                    />
                  </div>
                </div>
              </article>
            ))}
          </div>

          {/* 好友系統 */}
          <div className="lp-friends">
            <div className="lp-friends-copy">
              <div className="lp-eyebrow">好友系統</div>
              <div className="lp-friends-title">把在意的人，加進命盤裡</div>
              <p className="lp-friends-desc">
                建立好友命盤、查看解析，一鍵和自己合盤——愛情或友情都能對照著看，可加標籤、可搜尋。
              </p>
            </div>

            <div className="lp-friends-tags">
              {FRIEND_TAGS.map((tag, index) => (
                <span
                  className={index === FRIEND_TAGS.length - 1 ? "is-plain" : ""}
                  key={tag}
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* 03 各類報告 */}
      <section className="lp-reports" id="reports">
        <div className="lp-inner">
          <div className="lp-section-head">
            <span className="lp-eyebrow">03 ／ 各類報告</span>
            <h2 className="lp-section-title">
              想深入的時候，交給一份完整的報告
            </h2>
            <p className="lp-section-desc">
              由元辰雲閣命理師的解盤邏輯生成，填好資料就開始產出，完成後永久收在「我的書房」隨時回看。
            </p>
          </div>

          <div className="lp-report-grid">
            {REPORTS.map((report) => (
              <article className="lp-report-card" key={report.key}>
                <div className="lp-report-cover">
                  <img src={report.mascot} loading="lazy" alt="" />
                </div>

                <div className="lp-report-body">
                  <h3 className="lp-report-title">{report.title}</h3>
                  <p className="lp-report-desc">{report.desc}</p>

                  <ul className="lp-point-list lp-point-list--sm">
                    {report.points.map((point) => (
                      <li key={point}>
                        <span className="lp-dot"></span>
                        <span>{point}</span>
                      </li>
                    ))}
                  </ul>

                  <div className="lp-report-foot">
                    <span className="lp-report-meta">{report.meta}</span>
                    <span className="lp-report-badge">{report.badge}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>

          {/* 購買流程 */}
          <div className="lp-flow">
            <div className="lp-flow-copy">
              <div className="lp-eyebrow">購買流程</div>
              <h3 className="lp-flow-title">
                選報告 → 填資料 → 等生成 → 進書房查看
              </h3>

              <ol className="lp-flow-steps">
                {PURCHASE_STEPS.map((step, index) => (
                  <li key={step}>
                    <span className="lp-flow-no">{index + 1}</span>
                    <span>{step}</span>
                  </li>
                ))}
              </ol>

              <span className="lp-flow-note">
                ※ 在 aAibo 解鎖的報告，會與元辰雲閣同步，不必花兩次錢。
              </span>
            </div>

            <div className="lp-flow-shots">
              <div className="lp-phone lp-phone--sm">
                <img
                  src={`${IMG}/shots/report-list1.jpg`}
                  loading="lazy"
                  alt="填寫報告資料"
                />
              </div>
              <div className="lp-phone lp-phone--sm lp-phone--offset">
                <img
                  src={`${IMG}/shots/report-list2.jpg`}
                  loading="lazy"
                  alt="報告生成中"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 下載 CTA */}
      <section className="lp-download" id="download">
        <div className="lp-download-glow"></div>

        <div className="lp-download-inner">
          <img
            className="lp-download-mascot"
            src={`${IMG}/aibo-pat.png`}
            loading="lazy"
            alt="艾波"
          />
          <div className="lp-badge">{STATUS_BADGE}</div>
          <h2 className="lp-download-title">今天起，讓艾波陪你看運勢</h2>
          <p className="lp-download-desc">{CTA_SUB}</p>
          {storeButtons}
        </div>
      </section>

      {/* 頁尾 */}
      <footer className="lp-footer">
        <div className="lp-footer-top">
          <img
            className="lp-footer-logo"
            src={`${IMG}/logo-wordmark-white.png`}
            loading="lazy"
            alt="aAibo"
          />

          <div className="lp-footer-cols">
            <div className="lp-footer-col">
              <span className="lp-footer-col-title">APP</span>
              <a
                href="#companion"
                onClick={(e) => scrollToSection(e, "companion")}
              >
                艾波陪伴
              </a>
              <a
                href="#features"
                onClick={(e) => scrollToSection(e, "features")}
              >
                四大功能
              </a>
              <a href="#reports" onClick={(e) => scrollToSection(e, "reports")}>
                各類報告
              </a>
              <a
                href={TERMS_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                服務條款
              </a>
              <a
                href={PRIVACY_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                隱私權政策
              </a>
            </div>

            <div className="lp-footer-col">
              <span className="lp-footer-col-title">元辰雲閣</span>
              <a href="/" target="_blank" rel="noopener noreferrer">
                官方網站
              </a>
              <a href="/story" target="_blank" rel="noopener noreferrer">
                品牌故事
              </a>
              <a
                href="https://lin.ee/rgH7m42C"
                target="_blank"
                rel="noopener noreferrer"
              >
                聯絡我們
              </a>
            </div>
          </div>
        </div>

        <div className="lp-footer-bottom">
          <span>Copyright © 2026 aAibo by Leinotek Co,.Ltd.</span>
          <span>命理內容僅供參考，重大決定請理性判斷。</span>
        </div>
      </footer>
    </div>
  );
};

export default LandingPageComponent;
